import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Chip, Stack, Typography } from '@mui/material';
import constants from '../../constants';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from "../../context/LanguageContext";
import { getUsageAccessInfo } from "../../services/helper";
import { useNavigate } from 'react-router-dom';
import Iconify from '../../components/Iconify';

// ===========================|| PROFILE MENU - UPGRADE PLAN CARD ||=========================== //

const InfoCard = () => {
  const navigate = useNavigate()
  const [paid, setPaid] = useState(false);
  const { currentUser } = useAuth();
  const { t } = useLanguage();
  const [timeLeftLabel, setTimeLeftLabel] = useState("");
  const labelGoPremium = t('labelGoPremium'); // Go Premium
  const labelUpgradeToPro = t('upgradeToPro'); // Upgrade to Pro
  const labelForALifetime = t('labelForALifetime'); // for a lifetime.
  const labelMissingSomething = t('labelMissingSomething'); // Missing Something?
  const labelRequestAFeature = t('labelRequestAFeature'); // Request a Feature!
  const lRequest = t('request'); // Request
  const desc = `${constants.premium.pricing.mini} ${labelForALifetime}`;

  const makePayment = () => {
    navigate('/dashboard/payment')
  }

  useEffect(() => {
    const accessInfo = getUsageAccessInfo(currentUser);
    setPaid(accessInfo.paid);
    if (currentUser) {
      setTimeLeftLabel(`Only ${accessInfo.daysLeft} days left`)
    }
  }, [currentUser]);

  return (
    <>
      {paid && (
        <Card sx={{ p: 2, border: (theme) => `1px solid ${theme.palette.divider}`, boxShadow: 0 }}>
          <Stack spacing={1.5}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: 'secondary.lighter',
                color: 'secondary.dark',
                display: 'grid',
                placeItems: 'center',
              }}
            >
              <Iconify icon="solar:chat-round-like-bold-duotone" width={22} height={22} />
            </Box>
            <Box>
              <Typography variant="subtitle1">{labelMissingSomething}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {labelRequestAFeature}
              </Typography>
            </Box>
            <Button variant="outlined" href={constants.support.feedbackForm} target="_blank" rel="noreferrer">
              {lRequest}
            </Button>
          </Stack>
        </Card>
      )}
      {currentUser && !paid && (
        <Card
          sx={{
            p: 2,
            color: 'common.white',
            background: 'linear-gradient(135deg, #171717 0%, #0F3D28 100%)',
            boxShadow: '0 16px 34px rgba(23, 23, 23, 0.18)',
          }}
        >
          <Stack spacing={1.5}>
            <Chip
              size="small"
              label={timeLeftLabel || 'Free plan'}
              sx={{ alignSelf: 'flex-start', bgcolor: 'rgba(255,255,255,0.12)', color: 'common.white', fontWeight: 700 }}
            />
            <Box>
              <Typography variant="subtitle1" sx={{ color: 'common.white' }}>
                {labelUpgradeToPro}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.68)' }}>
                {desc}
              </Typography>
            </Box>
            <Button variant="contained" onClick={makePayment} sx={{ bgcolor: 'common.white', color: 'primary.main', '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' } }}>
              {labelGoPremium}
            </Button>
          </Stack>
        </Card>
      )}
    </>
  );
};

export default InfoCard;
